import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  viewProfile
} from './wholesalerAPI';


export const viewProfileAsync = createAsyncThunk(
  'wholesaler/viewProfile',
  async (username) => {
    const response = await viewProfile(username);
    return response;
  }
);

const initialState = {
  profile: null,
  orders: [],
  loading: false,
  error: null,
  userProfile: null,
  profileLoading: false,
  profileError: null
};

const wholesalerSlice = createSlice({
  name: 'wholesaler',
  initialState,
  reducers: {
    clearProfile: (state) => {
      state.profile = null;
      state.userProfile = null;
      state.profileError = null;
    },
    clearOrders: (state) => {
      state.orders = [];
    }
  },
  extraReducers: (builder) => {
    builder
      // View Profile
      .addCase(viewProfileAsync.pending, (state) => {
        state.profileLoading = true;
        state.profileError = null;
      })
      .addCase(viewProfileAsync.fulfilled, (state, action) => {
        state.profileLoading = false;
        state.userProfile = action.payload;
      })
      .addCase(viewProfileAsync.rejected, (state, action) => {
        state.profileLoading = false;
        state.profileError = action.error.message;
      });
  }
});

export const { 
  clearProfile,
  clearOrders
} = wholesalerSlice.actions;

export default wholesalerSlice.reducer;

export const selectUserProfile = (state) => state.wholesaler.userProfile;
export const selectProfileLoading = (state) => state.wholesaler.profileLoading;
export const selectProfileError = (state) => state.wholesaler.profileError; 
